/**
 * 微信表情包相关js
 */
export default {
	// 表情包图片根路径
	path: '/img/emoji/',
	// 表情与图片的对应关系
	emoji:{
        0: "微笑",
        1: "撇嘴",
        2: "色",
        3: "发呆",
        4: "得意",
        5: "流泪",
        6: "害羞",
        7: "闭嘴",
        8: "睡",
        9: "大哭",
        10: "尴尬",
        11: "发怒",
        12: "调皮",
        13: "呲牙",
        14: "惊讶",
        15: "难过",
        16: "酷",
        17: "冷汗",
        18: "抓狂",
        19: "吐",
        20: "偷笑",
        // 21: "可爱",
        22: "白眼",
        23: "傲慢",
        24: "饥饿",
        25: "困",
        26: "惊恐",
        27: "流汗",
        28: "憨笑",
        // 29: "大兵",
        30: "奋斗",
        31: "咒骂",
        32: "疑问",
        33: "嘘",
        34: "晕",
        // 35: "折磨",
        36: "衰",
        37: "骷髅",
        38: "敲打",
        39: "再见",
        40: "擦汗",
        41: "抠鼻",
        42: "鼓掌",
        43: "糗大了",
        44: "坏笑",
        45: "左哼哼",
        46: "右哼哼",
        47: "哈欠",
        48: "鄙视",
        49: "委屈",
        50: "快哭了",
        51: "阴险",
        52: "亲亲",
        53: "吓",
        54: "可怜",
        55: "菜刀",
        56: "西瓜",
        57: "啤酒",
        58: "篮球",
        59: "乒乓",
        60: "咖啡",
        61: "饭",
        62: "猪头",
        63: "玫瑰",
        64: "凋谢",
        // 65: "示爱",
        66: "爱心",
        67: "心碎",
        68: "蛋糕",
        69: "闪电",
        70: "炸弹",
        71: "刀",
        72: "足球",
        73: "瓢虫",
        74: "便便",
        75: "月亮",
        76: "太阳",
        77: "礼物",
        78: "拥抱",
        79: "强",
        80: "弱",
        81: "握手",
        82: "胜利",
        83: "抱拳",
        84: "OK",
        85: "勾引",
        86: "拳头",
        87: "差劲",
        88: "爱你",
        89: "NO",
        90: "OK",
        91: "奸笑",
        92: "嘿哈",
        93: "捂脸",
        94: "机智",
        95: "耶",
        96: "皱眉",
        97: "嘴唇",
        98: "发抖",
        99: "红包",
        100: "囧",
        101: "怄火",
        102: "跳跳",
        103: "转圈",
        104: "悠闲",
        105: "愉快",
		106: "吃瓜",
		107: "加油",
		108: "汗",
		109: "天啊",
		110: "Emm",
		111: "社会社会",
		112: "旺柴",
		113: "好的",
		114: "打脸",
		115: "加油加油",
		116: "哇",
		117: "發",
		118: "福",
		900: "\uE40C",
		901: "\uE412",
		902: "\uE409",
		903: "\uE40D",
		904: "\uE107",
		905: "\uE403",
		906: "\uE40E",
		907: "\uE41D",
		908: "\uE14C",
		909: "\uE312",
		910: "\uE112"
    },
	
	// 自定义表情对应关系-对应的是图片地址，图片位于oss-hello目录
	hello:{
		0: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/0.gif",
		1: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/1.png",
		2: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/2.jpg",
		3: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/3.png",
		4: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/4.gif",
		5: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/5.gif",
		6: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/6.gif",
		7: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/7.gif",
		8: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/8.png",
		9: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/9.png",
		10: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/10.gif",
		11: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/11.png",
		12: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/12.gif",
		13: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/13.png",
		14: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/14.jpg",
		15: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/15.gif",
		16: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/16.gif",
		17: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/17.gif",
		18: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/18.gif",
		19: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/19.gif",
		20: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/20.gif",
		21: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/21.gif",
		22: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/22.gif",
		23: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/23.gif",
		24: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/24.gif",
		25: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/25.gif",
		26: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/26.gif",
		27: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/27.gif",
		28: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/28.gif",
		29: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/29.gif",
		30: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/30.gif",
		31: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/31.gif",
		32: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/32.gif",
		33: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/33.gif",
		34: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/34.gif",
		35: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/35.gif",
		36: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/36.gif",
		37: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/37.gif",
		38: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/38.gif",
		39: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/39.gif",
		40: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/40.gif",
		41: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello/41.gif",
	},
	
	// 自定义表情对应关系-对应的是图片地址，图片位于oss-hello2目录
	hello2:{
		0: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/0.gif",
		1: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/1.gif",
		2: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/2.gif",
		3: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/3.gif",
		4: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/4.gif",
		5: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/5.gif",
		6: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/6.gif",
		7: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/7.gif",
		8: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/8.gif",
		9: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/9.gif",
		10: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/10.gif",
		11: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/11.gif",
		12: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/12.jpg",
		13: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/13.gif",
		14: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/14.gif",
		15: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/15.gif",
		16: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/16.jpg",
		17: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/17.gif",
		18: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/18.gif",
		19: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/19.gif",
		20: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/20.gif",
		21: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/21.gif",
		22: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/22.jpg",
		23: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/23.gif",
		24: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/24.gif",
		25: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/25.gif",
		26: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/26.gif",
		27: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/27.gif",
		28: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/28.gif",
		29: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/29.gif",
		30: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello2/30.gif"
	},
	
	// 自定义表情对应关系-对应的是图片地址，图片位于oss-hello3目录
	hello3:{
		0: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/0.gif",
		1: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/1.gif",
		2: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/2.gif",
		3: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/3.gif",
		4: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/4.gif",
		5: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/5.jpg",
		6: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/6.jpg",
		7: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/7.gif",
		8: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/8.gif",
		9: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/9.gif",
		10: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/10.gif",
		11: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/11.gif",
		12: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/12.gif",
		13: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/13.gif",
		14: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/14.gif",
		15: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/15.gif",
		16: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/16.gif",
		17: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/17.gif",
		18: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/18.gif",
		19: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello3/19.gif"
	},
	// 自定义表情对应关系-对应的是图片地址，图片位于oss-hello4目录
	hello4:{
		0: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/0.gif",
		1: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/1.gif",
		2: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/2.gif",
		3: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/3.gif",
		4: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/4.gif",
		5: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/5.gif",
		6: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/6.gif",
		7: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/7.gif",
		8: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/8.gif",
		9: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/9.gif",
		10: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/10.gif",
		11: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/11.gif",
		12: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/12.jpg",
		13: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/13.gif",
		14: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/14.jpg",
		15: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/15.gif",
		16: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/16.gif",
		17: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/17.gif",
		18: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/18.gif",
		19: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/19.gif",
		20: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/20.jpg",
		21: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/21.jpg",
		22: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/22.jpg",
		23: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/23.jpg",
		24: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/24.gif",
		25: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/25.jpg",
		26: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/26.jpg",
		27: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/27.jpg",
		28: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/28.gif",
		29: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/29.jpg",
		30: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/30.gif",
		31: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/31.gif",
		32: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/32.gif",
		33: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/33.gif",
		34: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/34.gif",
		35: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/35.gif",
		36: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello4/36.gif"
	},
	// 自定义表情对应关系-对应的是图片地址，图片位于oss-hello5目录
	hello5:{
		0: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/0.gif",
		1: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/1.png",
		2: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/2.png",
		3: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/3.gif",
		4: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/4.gif",
		5: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/5.gif",
		6: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/6.png",
		7: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/7.png",
		8: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/8.gif",
		9: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/9.png",
		10: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/10.png",
		11: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/11.png",
		12: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/12.png",
		13: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/13.gif",
		14: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/14.gif",
		15: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/15.png",
		16: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/16.png",
		17: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/17.gif",
		18: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/18.png",
		19: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/19.gif",
		20: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/20.png",
		21: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/21.gif",
		22: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/22.png",
		23: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/23.png",
		24: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/24.png",
		25: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/25.gif",
		26: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/26.gif",
		27: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/27.gif",
		28: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/28.gif",
		29: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/29.gif",
		30: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/30.png",
		31: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/31.gif",
		32: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/32.png",
		33: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/33.gif",
		34: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/34.png",
		35: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/35.png",
		36: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/36.gif",
		37: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/37.gif",
		38: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/38.png",
		39: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/39.gif",
		40: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/40.gif",
		41: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/41.gif",
		42: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/42.gif",
		43: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/43.gif",
		44: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/44.gif",
		45: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/45.gif",
		46: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/46.gif",
		47: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/47.gif",
		48: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/48.gif",
		49: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/49.png",
		50: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/50.png",
		51: "https://yswl-image.oss-cn-hangzhou.aliyuncs.com/img/emoji/hello5/51.gif"
	},
	// 生成表情包信息列表
	list(type){
		let emojiList = []
		if(type === undefined || type === "" || type === 'emoji'){
			for(let i in this.emoji){
				emojiList.push({
					path: this.path + i + '.png',
					title: this.emoji[i],
					key: i,
					type: 'emoji'
				})
			}
		}else{
			if(this[type] !== undefined){
				for(let i in this[type]){
					emojiList.push({
						path: this[type][i],
						title: i,
						key: i,
						type: type
					})
				}
			}
		}
		return emojiList
	},
	
	// 根据键名找对应的值
	get(key){
		if(this.emoji[key] === undefined){
			key = 0
		}
		if(key < 900){
			return '['+this.emoji[key]+']'
		}else{
			return this.emoji[key]
		}
	}
	
}